
































import { Component } from "vue-property-decorator";
import { required } from "@/shared/validators";
import Modal from "@/shared/components/modal.vue";
import GlobalMixin from "@/shared/mixins/globalMixin";
import { mixins } from "vue-class-component";
import { LeadService, Lead } from "@/services/lead.service";
import ComboEtapaLead from "../components/ComboEtapaLead.vue";

@Component({
  components: { Modal, ComboEtapaLead },
})
export default class MudarEtapa extends mixins(GlobalMixin) {
  loading = false;
  lead: Lead = {} as Lead;
  observacao: string | null = null;
  idEtapaLead: number | null = null;

  rules = {
    idEtapaLead: [required()],
  };

  fechar() {
    const modal = this.$refs.modal as Modal;
    modal.close(false);
  }

  public async mudarEtapa(idLead: number) {
    this.lead.idLead = idLead;
    const modal = this.$refs.modal as Modal;
    const p = modal.open();

    return p;
  }

  async registrarMudanca() {
    const modal = this.$refs.modal as Modal;
    const form = this.$refs.form as any;

    if (form.validate()) {
      this.loading = true;
      this.lead.idEtapaLead = this.idEtapaLead!;
      try {
        if (this.lead) {
          await LeadService.mudarEtapa(this.lead, this.observacao);
          form.reset();
        }
        return modal.close(true);
      } finally {
        this.loading = false;
      }
    }
  }
}
